import { api } from './api';

export interface CoProducer {
        id: string;
        email: string;
        joinDate: string;
        status: string
        invite: {
            participate_affiliates_sales: boolean;
            participate_producer_sales: boolean;
            percentage?: string;
            percentage_formatted?: string;
            commission_value?: string;
            commission_value_formatted?: string;
            commission_rule_type?: string;
            role: string;
            user: {
                id: string;
                name: string;
                created_at: string;
            } | null;
        }
}

export interface CreateCoProducerDTO {
    email: string;
    role: string;
    percentage: string;
    participate_producer_sales: boolean;
    participate_affiliates_sales: boolean;
}

export interface UpdateCoProducerDTO {
    percentage: string;
    participate_producer_sales: boolean;
    participate_affiliates_sales: boolean;
}

export interface PaginatedResponse<T> {
    data: T[];
    meta: {
        current_page: number;
        from: number;
        last_page: number;
        per_page: number;
        to: number;
        total: number;
    };
    links: {
        first: string | null;
        last: string | null;
        next: string | null;
        prev: string | null;
    };
}

export const coproducerService = {
    getAll: async (productId: string, page: number = 1): Promise<PaginatedResponse<CoProducer>> => {
        const response = await api.get(`/v1/products/${productId}/invitations?page=${page}`);
        return response.data;
    },

    create: async (productId: string, data: CreateCoProducerDTO): Promise<CoProducer> => {
        const response = await api.post(`/v1/products/${productId}/invitations`, {
            ...data,
            email: data.email?.trim().toLowerCase(),
        });
        return response.data;
    },

    update: async (productId: string, productInviteId: string,  data: UpdateCoProducerDTO ): Promise<CoProducer> => {
        const response = await api.put(`/v1/products/${productId}/invitations/${productInviteId}`, data);
        return response.data;
    },

    delete: async (productId: string, productInviteId:string): Promise<void> => {
        await api.delete(`/v1/products/${productId}/invitations/${productInviteId}`);
    }
};